<template>
  <v-card outlined style="margin-top: 2px; height: calc(100vh - 8.5rem); display: flex !important; flex-direction: column; padding-top: 10px; padding-bottom: 10px;">
    <v-card-text style="flex-grow: 1; overflow: auto;">

      <div id="mapContainer">
      <img id="mapImage" src="merged_16-3km.png" alt="Карта">
      <div id="info"></div>
      <div id="marker"></div>
    </div>

    </v-card-text>
  </v-card>



</template>

<script>

export default {
  name: "offlineMaps",
  props: {

  },

  data() {
    return {
      show: true,
      coords: [],

      container: document.getElementById("mapContainer"),
      img: document.getElementById("mapImage"),
      info: document.getElementById("info"),
      marker: document.getElementById("marker"),

      // // Границы карты 3km, 17zoom
      // MAP_MIN_LAT: 61.75797297297297,
      // MAP_MAX_LAT: 61.81202702702702,
      // MAP_MIN_LON: 34.289733997208046,
      // MAP_MAX_LON: 34.40406600279195,

      // // Границы карты 5km, 14zoom
      // MAP_MIN_LAT: 61.73995495495495,
      // MAP_MAX_LAT: 61.83004504504504,
      // MAP_MIN_LON: 34.25162332868008,
      // MAP_MAX_LON: 34.44217667131991,

      // // Границы карты 3km, 15zoom
      // MAP_MIN_LAT: 61.75797297297297,
      // MAP_MAX_LAT: 61.81202702702702,
      // MAP_MIN_LON: 34.289733997208046,
      // MAP_MAX_LON: 34.40406600279195,

      // Границы карты 3km, 16zoom
      MAP_MIN_LAT: 61.75797297297297,
      MAP_MAX_LAT: 61.81202702702702,
      MAP_MIN_LON: 34.289733997208046,
      MAP_MAX_LON: 34.40406600279195,

      scale: 1,
      minScale: 0.05,
      maxScale: 12.05,

      offsetX: 0,
      offsetY: 0,

      isDragging: false,
      lastX: 0,
      lastY: 0,

      markerLat: null, 
      markerLon: null,

      touchMode: null,
      lastTouchX: 0,
      lastTouchY: 0,

      pinchStartDist: 0,
      pinchStartScale: 1,
      pinchCenterX: 0,
      pinchCenterY: 0,

      markerX: 0,
      markerY: 0,

      markerDragging: false,
      markerLastX: 0,
      markerLastY: 0,

      trimLat: 0,
      trimLon: 0,

    }
  },


  mounted() {

    this.container = document.getElementById("mapContainer"),
    this.img = document.getElementById("mapImage"),
    this.info = document.getElementById("info"),
    this.marker = document.getElementById("marker"),

    this.img.addEventListener("load", () => {
      const rect = this.container.getBoundingClientRect();
      const imgWidth = this.img.naturalWidth;
      const imgHeight = this.img.naturalHeight;

      this.scale = Math.min(rect.width / imgWidth, rect.height / imgHeight);

      const scaledWidth = imgWidth * this.scale;
      const scaledHeight = imgHeight * this.scale;

      this.offsetX = (rect.width - scaledWidth) / 2;
      this.offsetY = (rect.height - scaledHeight) / 2;

      this.applyTransform();
      this.setMarkerByGps(61.785, 34.3469);
    });

    this.container.addEventListener("contextmenu", (e) => e.preventDefault());
    
    this.container.addEventListener("mousedown", (e) => {
      // Только правая / левая кнопка мыши 
      // if (e.button !== 2) return;

      e.preventDefault();

      this.isDragging = true;
      this.lastX = e.clientX;
      this.lastY = e.clientY;
      this.container.style.cursor = "grabbing";
    });

    window.addEventListener("mouseup", () => {
      this.isDragging = false;
      this.container.style.cursor = "grab";
    });

    window.addEventListener("mousemove", (e) => {
      if (!this.isDragging) return;

      const dx = e.clientX - lastX;
      const dy = e.clientY - lastY;

      this.lastX = e.clientX;
      this.lastY = e.clientY;

      this.offsetX += dx;
      this.offsetY += dy;

      this.clampOffsets();
      this.applyTransform();
    });

    this.marker.addEventListener("mousedown", (e) => {
      e.stopPropagation(); // чтобы не двигалась карта
      if (e.button !== 0) return; // только левая кнопка

      this.markerDragging = true;
      this.markerLastX = e.clientX;
      this.markerLastY = e.clientY;
      this.marker.style.cursor = "grabbing";
    });

    window.addEventListener("mouseup", () => {
      this.markerDragging = false;
      this.marker.style.cursor = "grab";
    });
    
    window.addEventListener("mousemove", (e) => {
      if (!this.markerDragging) return;

      const dx = e.clientX - this.markerLastX;
      const dy = e.clientY - this.markerLastY;

      this.markerLastX = e.clientX;
      this.markerLastY = e.clientY;

      // dx, dy → смещение в пикселях карты
      const mapX = (this.offsetX + this.gpsToMapXY(this.markerLat, this.markerLon).x * this.scale + dx - this.offsetX) / this.scale;
      const mapY = (this.offsetY + this.gpsToMapXY(this.markerLat, this.markerLon).y * this.scale + dy - this.offsetY) / this.scale;

      // пересчёт в GPS
      const gps = this.mapXYToGps(mapX, mapY);

      this.markerLat = gps.lat;
      this.markerLon = gps.lon;

      this.updateMarkerPosition();
    
    });

    this.container.addEventListener("click", (e) => {
      if (e.button === 2) return; // правая кнопка — панорамирование

      const rect = this.container.getBoundingClientRect();
      const mouseX = e.clientX - rect.left;
      const mouseY = e.clientY - rect.top;

        // экран → карта
      const mapX = (mouseX - this.offsetX) / this.scale;
      const mapY = (mouseY - this.offsetY) / this.scale;

        // карта → GPS
      const gps = this.mapXYToGps(mapX, mapY);

      this.markerLat = gps.lat;
      this.markerLon = gps.lon;

      this.updateMarkerPosition();

      console.log("Marker GPS:", this.markerLat + this.trimLat, this.markerLon + this.trimLon);
    });

    this.container.addEventListener("wheel", (e) => {
      e.preventDefault();

      const rect = this.container.getBoundingClientRect();
      const mouseX = e.clientX - rect.left;
      const mouseY = e.clientY - rect.top;

      const zoomFactor = 2.1;
      let newScale = this.scale * (e.deltaY < 0 ? zoomFactor : 1 / zoomFactor);

      newScale = Math.max(this.minScale, Math.min(this.maxScale, newScale));
      if (newScale === this.scale) return;

      const imgX = (mouseX - this.offsetX) / this.scale;
      const imgY = (mouseY - this.offsetY) / this.scale;

      this.scale = newScale;
      this.offsetX = mouseX - imgX * this.scale;
      this.offsetY = mouseY - imgY * this.scale;

      this.clampOffsets();
      this.applyTransform();
    }, { passive: false });

    this.container.addEventListener("touchstart", (e) => {
      e.preventDefault();

      if (e.touches.length === 1) {
        this.touchMode = "pan";
        this.lastTouchX = e.touches[0].clientX;
        this.lastTouchY = e.touches[0].clientY;
      } else if (e.touches.length === 2) {
        this.touchMode = "pinch";

        const t1 = e.touches[0];
        const t2 = e.touches[1];

        this.pinchStartDist = this.distance(t1, t2);
        this.pinchStartScale = this.scale;

        const rect = this.container.getBoundingClientRect();
        this.pinchCenterX = (t1.clientX + t2.clientX) / 2 - rect.left;
        this.pinchCenterY = (t1.clientY + t2.clientY) / 2 - rect.top;
      }
    });

    this.container.addEventListener("touchmove", (e) => {
      e.preventDefault();

      if (this.touchMode === "pan" && e.touches.length === 1) {
        const t = e.touches[0];
        const dx = t.clientX - this.lastTouchX;
        const dy = t.clientY - this.lastTouchY;

        this.lastTouchX = t.clientX;
        this.lastTouchY = t.clientY;

        this.offsetX += dx;
        this.offsetY += dy;
            
        this.clampOffsets();
        this.applyTransform();
      }

      if (this.touchMode === "pinch" && e.touches.length === 2) {
        const t1 = e.touches[0];
        const t2 = e.touches[1];

        const newDist = this.distance(t1, t2);
        let newScale = this.pinchStartScale * (newDist / this.pinchStartDist);

        newScale = Math.max(this.minScale, Math.min(this.maxScale, newScale));

        const imgX = (this.pinchCenterX - this.offsetX) / this.scale;
        const imgY = (this.pinchCenterY - this.offsetY) / this.scale;

        this.scale = newScale;
        this.offsetX = this.pinchCenterX - imgX * this.scale;
        this.offsetY = this.pinchCenterY - imgY * this.scale;

        this.applyTransform();
      }
    });

    this.container.addEventListener("touchend", () => {
      if (event.touches.length === 0) this.touchMode = null;
    });

    this.marker.addEventListener("touchstart", (e) => {
      e.stopPropagation();
      const t = e.touches[0];
      this.markerDragging = true;
      this.markerLastX = t.clientX;
      this.markerLastY = t.clientY;
    });

    this.marker.addEventListener("touchmove", (e) => {
      e.stopPropagation();
      if (!this.markerDragging) return;

      const t = e.touches[0];
      const dx = t.clientX - this.markerLastX;
      const dy = t.clientY - this.markerLastY;

      this.markerLastX = t.clientX;
      this.markerLastY = t.clientY;

        // markerX += dx / scale;
        // markerY += dy / scale;
        // updateMarkerPosition();

        // dx, dy → смещение в пикселях карты
      const mapX = (this.offsetX + this.gpsToMapXY(this.markerLat, this.markerLon).x * this.scale + dx - this.offsetX) / this.scale;
      const mapY = (this.offsetY + this.gpsToMapXY(this.markerLat, this.markerLon).y * this.scale + dy - this.offsetY) / this.scale;

        // пересчёт в GPS
      const gps = this.mapXYToGps(mapX, mapY);

      this.markerLat = gps.lat;
      this.markerLon = gps.lon;

      this.updateMarkerPosition();

    });

    this.marker.addEventListener("touchend", () => {
      this.markerDragging = false;
    });

  },

  
  methods: {
    applyTransform() {
      this.img.style.transform = `translate(${this.offsetX}px, ${this.offsetY}px) scale(${this.scale})`;
      this.updateMarkerPosition();
      this.info.textContent = `scale: ${this.scale.toFixed(2)}, offsetX: ${this.offsetX.toFixed(0)}, offsetY: ${this.offsetY.toFixed(0)}`;
    },

    updateMarkerPosition() {
      if (this.markerLat === null) return;

      const { x, y } = this.gpsToMapXY(this.markerLat, this.markerLon);

      const px = this.offsetX + x * this.scale;
      const py = this.offsetY + y * this.scale;

      this.marker.style.left = px + "px";
      this.marker.style.top = py + "px";
      this.marker.style.display = "block";
    },

    clampOffsets() {
      const rect = this.container.getBoundingClientRect();
      const imgWidth = this.img.naturalWidth * this.scale;
      const imgHeight = this.img.naturalHeight * this.scale;

      // Если карта меньше контейнера — центрируем
      if (imgWidth <= rect.width) {
        this.offsetX = (rect.width - imgWidth) / 2;
      } else {
        this.offsetX = Math.min(0, Math.max(this.offsetX, rect.width - imgWidth));
      }

      if (imgHeight <= rect.height) {
        this.offsetY = (rect.height - imgHeight) / 2;
      } else {
        this.offsetY = Math.min(0, Math.max(this.offsetY, rect.height - imgHeight));
      }
    },

    distance(t1, t2) {
      return Math.hypot(t2.clientX - t1.clientX, t2.clientY - t1.clientY);
    },

    gpsToMapXY(lat, lon) {
      const x = (lon - this.MAP_MIN_LON) / (this.MAP_MAX_LON - this.MAP_MIN_LON) * this.img.naturalWidth;

      const latRad = lat * Math.PI / 180;
      const mercY = Math.log(Math.tan(Math.PI/4 + latRad/2));

      const minLatRad = this.MAP_MIN_LAT * Math.PI / 180;
      const maxLatRad = this.MAP_MAX_LAT * Math.PI / 180;

      const minMercY = Math.log(Math.tan(Math.PI/4 + minLatRad/2));
      const maxMercY = Math.log(Math.tan(Math.PI/4 + maxLatRad/2));

      const y = (maxMercY - mercY) / (maxMercY - minMercY) * this.img.naturalHeight;

      return { x, y };
    },

    mapXYToGps(x, y) {
      const lon = this.MAP_MIN_LON + (x / this.img.naturalWidth) * (this.MAP_MAX_LON - this.MAP_MIN_LON);

      const minLatRad = this.MAP_MIN_LAT * Math.PI / 180;
      const maxLatRad = this.MAP_MAX_LAT * Math.PI / 180;

      const minMercY = Math.log(Math.tan(Math.PI/4 + minLatRad/2));
      const maxMercY = Math.log(Math.tan(Math.PI/4 + maxLatRad/2));

      const mercY = maxMercY - (y / this.img.naturalHeight) * (maxMercY - minMercY);
      const lat = (2 * Math.atan(Math.exp(mercY)) - Math.PI/2) * 180/Math.PI;

      return { lat, lon };
    },

    setMarkerByGps(lat, lon) {
      this.markerLat = lat;
      this.markerLon = lon;
      this.updateMarkerPosition();
    },

  },

};

</script>



<style scoped>
html,
body {
  display: flex;
}

#mapContainer {
  border-radius: 6px;
  width: 100%;
  height: 100%;
  background: #222;
  overflow: hidden;
  position: relative;
  touch-action: none;
  /* важно для тач‑жестов */
  cursor: grab;
}

#mapImage {
  position: absolute;
  top: 0;
  left: 0;
  transform-origin: 0 0;
  image-rendering: auto;
}

#info {
  position: absolute;
  left: 10px;
  bottom: 10px;
  background: rgba(0, 0, 0, 0.5);
  color: #fff;
  padding: 4px 8px;
  font-size: 12px;
  border-radius: 4px;
  pointer-events: none;
}

#marker {
  width: 15px;
  height: 15px;
  background: rgb(0, 132, 255);
  border-radius: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
  cursor: grab;
  z-index: 10;
}
</style>
